module.exports = __webpack_public_path__ + "img/4_100.9ca6cec6.png";